export class OtherDesign {
  constructor(
    public id: string,
    public name: string,
    public thumbnailUrl: string,
  ) {}
}
